import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import React from 'react';
import { labelToID } from '../util/util';

interface Props {
	items: any[];
	actions: any[];
	origin: string;
	children: any;
}

export default function HeaderUserActionsList({
	items,
	actions,
	origin = 'right',
	children,
}: Props) {
	const [anchorEl, setAnchorEl] = React.useState(null);

	if ((!items && !actions) || (!items.length && !actions.length)) {
		return null;
	} // do not display button if there are no items or actions

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				id='AppBar__Button--UserActionsDropdown'
				color='navLink'
				onClick={handleClick}
				sx={{ whiteSpace: 'nowrap' }}
				endIcon={<ArrowDropDown />}
			>
				{children}
			</Button>
			<Popover
				id='AppBar__UserActionsDropdown'
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				sx={{ mt: 2 }}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: origin === 'right' ? 'right' : 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: origin === 'right' ? 'right' : 'left',
				}}
			>
				{/*
					Have to explicitly make origins 'right' or 'left' or else it will throw an error.
				*/}
				{/*
					checks if items or actions exist, allowing this component to be used if 
					only a list of items or only a list of buttons is passed in
					(if both are passed in, the divider is rendered)
				*/}
				<List id='UserActionsDropdown__List'>
					{items.length
						? items.map((listItem, index) => {
								return (
									<ListItem
										key={index}
										id={`UserActionsDropdown__ListItem--${labelToID(
											listItem.label,
										)}`}
									>
										<ListItemIcon sx={{ mr: 2, minWidth: 24 }}>
											{listItem.icon}
										</ListItemIcon>

										<ListItemText primary={listItem.label} />
									</ListItem>
								);
						  })
						: null}

					{items && items.length && actions && actions.length ? (
						<Divider sx={{ my: 1 }} />
					) : null}

					{actions.length
						? actions.map((listItem, index) => {
								return (
									<ListItem
										key={index}
										id={`UserActionsDropdown__ListAction--${labelToID(
											listItem.label,
										)}`}
										disablePadding
									>
										<ListItemButton
											onClick={() => {
												listItem.callback();
												handleClose();
											}}
											color='inherit'
										>
											<ListItemIcon sx={{ mr: 2, minWidth: 24 }}>
												{listItem.icon}
											</ListItemIcon>

											<ListItemText primary={listItem.label} />
										</ListItemButton>
									</ListItem>
								);
						  })
						: null}
				</List>
			</Popover>
		</>
	);
}
